"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEArtNrGeneratorService = void 0;
const AEArtNrGeneratorFactory_1 = require("./AEArtNrGeneratorFactory");
/**
 * The `AEArtNrGeneratorService` helps creating article numbers for AE's
 */
class AEArtNrGeneratorService {
    /**
     * Generate a new AEArtNr with the properly structured format
     */
    static generateAEArtNr(artNr, options) {
        const generator = AEArtNrGeneratorFactory_1.AEArtNrGeneratorFactory.instanceOf(artNr);
        return generator.generateAEArtNr(artNr, options);
    }
}
exports.AEArtNrGeneratorService = AEArtNrGeneratorService;
//# sourceMappingURL=AEArtNrGeneratorService.js.map